export const openCentralizedPopupWindow = (
  url: string,
  windowName: string,
  width: number = 500,
  height: number = 800
): WindowProxy | null => {
  // Fixes dual-screen position Most browsers Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const clientWidth =
    window.innerWidth || document.documentElement.clientWidth || screen.width;
  const clientHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    screen.height;

  const left = (clientWidth - width) / 2 + dualScreenLeft;
  const top = (clientHeight - height) / 2 + dualScreenTop;

  return window.open(
    url,
    windowName,
    `width=${width},height=${height},left=${left},top=${top}`
  );
};

export const onWindowPopupCloseRefresh = (
  newWindow: Window,
  newHref?: string
) => {
  const timer = setInterval(function() {
    if (newWindow.closed) {
      window.location.href = newHref || newWindow.location.href;
      clearInterval(timer);
    }
  }, 1000);
};

export const closeOnWindowPopupUrlMatches = (
  newWindow: Window,
  url: string,
  newHref?: string
) => {
  const timer = setInterval(function() {
    if (newWindow.location.href.includes(url)) {
      newWindow.close();
      window.location.href = newHref || newWindow.location.href;
      clearInterval(timer);
    }
  }, 1000);
};

export const onSigninPopupCloseRedirect = (newWindow: any) => {
  const timer = setInterval(function() {
    if (newWindow.closed) {
      clearInterval(timer);
    }

    if (newWindow.connectedThoughtProvider) {
      window.location.href =
        newWindow.connectionRedirectUrl || window.location.href;
      newWindow.close();
      clearInterval(timer);
    }
  }, 1000);
};
